/* @flow */
import * as React from 'react';

const Undo = props => (
  <svg width={11} height={14} viewBox="0 0 11 14" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="nonzero"
      d="M5.333,2.667 L5.333,0 L2,3.333 L5.333,6.667 L5.333,4 C7.543,4 9.333,5.79 9.333,8 C9.333,10.21 7.543,12 5.333,12 C3.123,12 1.333,10.21 1.333,8 L0,8 C0,10.947 2.387,13.333 5.333,13.333 C8.28,13.333 10.667,10.947 10.667,8 C10.667,5.053 8.28,2.667 5.333,2.667 Z"
    />
  </svg>
);

export default Undo;



// WEBPACK FOOTER //
// ./src/assets/images/icons/undo.js